var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader'),(_vm.savedRoutes)?_c('keep-alive',{attrs:{"include":_vm.savedRoutes}},[_c('router-view')],1):_c('router-view'),(_vm.$route.name !== _vm.routeNames().SIGN_IN)?_c('AppFooter'):_vm._e(),_c('AppSprite')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }